/**
 * Component per mostrar informació
 * Component: InfoDialog.tsx
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 06/04/2020
 * (c) Ajuntament de Manresa - set 2017 - Departament de Sistemes d'Informació
 */

import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TableContainer } from '@material-ui/core';
import DataGrid from 'ajt-data-grid';
import DataGridField from 'ajt-data-grid/lib/src/DataGridField';
import Util from '../config/util';
import AppState from '../states/AppState';

interface IPropsInfoDialog {
    appState: AppState;
    onClose: () => void;
};

interface ILinia {
    nom: string;
    descr: string;
    fanals: number;
    empls: number;
}

@observer
export default class InfoDialog extends React.Component<IPropsInfoDialog, {}> {
    constructor(props: IPropsInfoDialog) {
        super(props);
        this.getInfo();
    }

    @observable linies: Array<ILinia> = [];

    /**
     * Recuperem la el número de lots i fanals de cada categoria
     */
     @action async getInfo() {
        const xreq: string = Util.getXMLRequest('GetEleFanalsInfo', ['Session', 'Usuari', 'EleCod'], [this.props.appState.usr.sesCod, Util.encodeHTML(this.props.appState.usr.userId), this.props.appState.ele.eleCod.toString()]);
        const resultat = await this.props.appState.req.postRequestRaw(this.props.appState.mapConfig.wsUrl, xreq, { headers: { 'Content-Type': 'text/xml;' } });
        const xresp: string = Util.getXMLResponse('GetEleFanalsInfo', resultat as string);
        let lins: Array<ILinia> = [];
        if (xresp) {
            let pos: { pos: number } = { pos: 0 };
            let xpartit: string = Util.getBetween('partitFar>', '</partitFar', xresp, pos);
            while (xpartit) {
                const nom: string = Util.getBetween('partitNom>', '</partitNom', xpartit, { pos: 0 });
                const descr: string = Util.getBetween('partitDesc>', '</partitDesc', xpartit, { pos: 0 });
                const fanals: number = parseInt(Util.getBetween('fanals>', '</fanals', xpartit, { pos: 0 }));
                const empls: number = parseInt(Util.getBetween('emplacaments>', '</emplacaments', xpartit, { pos: 0 }));
                lins.push({nom, descr, fanals, empls});
                xpartit = Util.getBetween('partitFar>', '</partitFar', xresp, pos);
            }
        }
        this.linies = lins;
    }
    
    // Tanca el diàleg
    private handleClose = () => {
        this.props.onClose();
    }

    // Render !
    render(): JSX.Element {

        // Rederitzem
        return (<Dialog 
                open={!!this.props.appState.showInfoDlg}
                onClose={this.handleClose}
                maxWidth={'md'}
                fullWidth={true}
            >
                <DialogTitle id="form-dialog-title">Informació</DialogTitle>
                <DialogContent>
                    <TableContainer style={{maxHeight: '250px'}}>
                        <DataGrid
                            fixedHeader={true}
                            showRowHover={true}
                            dataSource={this.linies}
                            size="small"
                        >
                            <DataGridField field="nom" title="PARTIT" width={100} style={{textAlign: 'left'}} styleHeader={{textAlign: 'left'}}/>
                            <DataGridField field="descr" title=" " width={600} style={{textAlign: 'left'}} styleHeader={{textAlign: 'left'}}/>
                            <DataGridField field="fanals" title="N.FANALS" width={100} style={{textAlign: 'right'}} styleHeader={{textAlign: 'left'}}/>
                            <DataGridField field="empls" title="N.EMPS" width={100} style={{textAlign: 'right'}} styleHeader={{textAlign: 'left'}}/>
                        </DataGrid>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose.bind(this)} color="secondary">Tancar</Button>
                </DialogActions>
            </Dialog>);
    }
}